var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBranded())?_c('div',[_c('div',{class:!_vm.isSushiHub && 'p-4'},[(_vm.showLogin)?_c('div',{staticClass:"login-container topmenu"},[_c('intro-login')],1):_vm._e(),_c('resturants-filter')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }